import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { 
  MainBodyContent,
} from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { 
  bgCompanyLimitBankPath,
} from 'routes'
import { 
  BottomActionsContainer,
} from './styled'
import { 
  getBGLimitOfBankDetail,
  updateBGLimitOfBank,
  getBGLBPermission,
  deleteBGLimitOfBank
} from 'ducks/bgLimitOfBank'
import { getCompanies } from 'ducks/options'
import { getBankOwners } from 'ducks/bankGuarantee'
import { validateField } from '../helper'
import InformationComponent from '../Shareds/Information'

const EditBGLimitOfBank = (props) => {

  const { 
    valueForm, 
    permission,
    history
  } = props

  const [showConfirm, setShowConfirm] = React.useState(false)
  const actionName = React.useRef(0);

  React.useEffect(()=>{
    if(!permission){
      history.replace(bgCompanyLimitBankPath)
    }
  },[permission])

  React.useEffect(() => {
    props.getBGLBPermission()
    props.getBGLimitOfBankDetail(props.match.params.id, history)
    props.getCompanies()
    props.getBankOwners()
  }, [])

  const getConfirmMessage = () =>{
    if(actionName.current == 'save'){
      return 'Are you sure?'
    }else {
      return `Do you want to delete Limit of Bank ${valueForm.companyName} and ${valueForm.bankName}?`
    }    
  }

  const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      setShowConfirm(true)
    })
  } 

  const confirmSubmit = () =>{
    setShowConfirm(false)
    if(actionName.current == 'save'){
      props.updateBGLimitOfBank(valueForm, history)
    }else {
      props.deleteBGLimitOfBank(valueForm.id, history)
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle='Limit of Bank - Edit'  
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'LB', content: 'Limit of Bank', link: true, onClick: () => history.push(bgCompanyLimitBankPath) },
              { key: 'LBEdit', content: 'Edit', active: true }
            ]
          }
        />
      }
    >
      <InformationComponent isEdit/>
      <div style={{height:'1rem'}}/>
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            content='Delete' 
            color='red' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>actionName.current = 'delete'}
          />  
          <Button 
            content='Save' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>actionName.current = 'save'}
          />
        </BottomActionsContainer>
      </form>
      <Confirm
        size='tiny'
        open={showConfirm}
        content={getConfirmMessage()}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => confirmSubmit()}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const valueForm = getFormValues('formBGLimitOfBank')(state) || {}

  return ({
    valueForm,
    permission: state.bgLimitOfBank.permission,
    initialValues: {
      ...state.bgLimitOfBank.detail.data
    },
  })
}

const mapDispatchToProps = {
  getBGLimitOfBankDetail,
  updateBGLimitOfBank,
  getCompanies,
  getBankOwners,
  getBGLBPermission,
  deleteBGLimitOfBank
}

const validate = (values) => {
  let errors = validateField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGLimitOfBank',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(EditBGLimitOfBank)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
